import AutoSubmitController from "./auto_submit_controller";

// Auto-submitting switch that asks for confirmation before it is turned OFF.
//
// Turbo's own `data-turbo-confirm` is not usable here: it fires in both directions, and
// when the user declines it aborts the submission without emitting an event, leaving the
// switch visually flipped to a state the server never stored. Owning the confirm here lets
// us restore the checkbox on decline. Assigning `.checked` fires no change event, so there
// is no loop back into this action.
//
// Extends AutoSubmitController for its offline-aware submitForm(); the inherited `input`
// and `submitOnEnter` actions are unused by this control.
export default class extends AutoSubmitController {
  // `delay` is inherited. Leaving `message` unset submits with no confirmation at all, so
  // any new caller must pass it.
  static values = { message: String };

  toggle(event) {
    const checkbox = event.target;

    if (!checkbox.checked && this.hasMessageValue && !window.confirm(this.messageValue)) {
      checkbox.checked = true;
      return;
    }

    // Submitting straight away rather than on a debounce means an ON click and a following
    // OFF click are two requests in flight at once. They are not equivalent — disabling
    // also cancels the member's orders, and does enough extra work to commit last — so the
    // switch stays locked until the server's row replaces it or the request finishes.
    this.element.addEventListener(
      "turbo:submit-end",
      () => { checkbox.disabled = false; },
      { once: true }
    );

    // Submit BEFORE locking. A disabled input is excluded from the form data, so locking
    // first sent only the hidden `enabled=false` and the server read every click as
    // "turn it off" -- switching auto-reserve ON silently turned it off instead.
    // requestSubmit builds the payload synchronously, so disabling after is safe.
    this.submitForm();
    checkbox.disabled = true;
  }
}
